// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconAavestkgho } from "../../../icons/mono/build/icon-aavestkgho.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const AavestkghoIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconAavestkgho.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  AavestkghoIcon.displayName = 'AavestkghoIcon';
}

export default AavestkghoIcon;